import {Component} from '@angular/core';
import {TopBarComponent} from "../top-bar/top-bar.component";
import {NgForOf, NgIf, NgOptimizedImage} from "@angular/common";
import {FooterPersonaComponent} from "../app-persona/footer-persona/footer-persona.component";
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-politics-privacity',
  standalone: true,
  imports: [
    TopBarComponent,
    NgOptimizedImage,
    NgForOf,
    NgIf,
    FooterPersonaComponent,
    RouterLink
  ],
  templateUrl: './politics-privacity.component.html',
  styleUrl: './politics-privacity.component.css'
})
export class PoliticsPrivacityComponent {

  name = 'Politica de Privacidad';
  intro = 'Somos un equipo humano con sólida experiencia en servicios de salud ambulatorios e integrales. Comprometido con el bienestar de nuestros usuarios. Nuestra Política de Privacidad y Protección de Datos Personales es aplicable a todos nuestros clientes en cualquiera de los servicios brindados.';
  especialidades: any = [
    {nombre: "Alergología"},
    {nombre: "Cardiología"},
    {nombre: "Cardiología Pediátrica"},
    {nombre: "Cirugía General"},
    {nombre: "Cirugía Pediátrica"},
    {nombre: "Cirugía Vascular / Flebología"},
    {nombre: "Dermatología"},
    {nombre: "Diabetología"},
    {nombre: "Ecografía"},
    {nombre: "Endocrinología"},
    {nombre: "Gastroenterología"},
    {nombre: "Ginecología"},
    {nombre: "Imagenología"},
    {nombre: "Mastología"},
    {nombre: "Medicina General"},
    {nombre: "Medicina Interna"},
    {nombre: "Medicina Ocupacional"},
    {nombre: "Nefrología"},
    {nombre: "Neumología"},
    {nombre: "Neurocirugía"},
    {nombre: "Neurología"},
    {nombre: "Nutrición"},
    {nombre: "Obstetricia"},
    {nombre: "Odontología"},
    {nombre: "Oftalmología"},
    {nombre: "Oftalmología Pediátrica"},
    {nombre: "Otorrinolaringología"},
    {nombre: "Pediatría"},
    {nombre: "Proctología"},
    {nombre: "Psicología Clínica"},
    {nombre: "Rayos X"},
    {nombre: "Reumatología"},
    {nombre: "Terapia física"},
    {nombre: "Traumatología"},
    {nombre: "Traumatología Pediátrica"},
    {nombre: "Urología"}

  ]
  serviciosAmbulatorios: any = [
    { nombre: "Atención primaria" },
    { nombre: "Laboratorio clínico" },
    { nombre: "Laboratorio patológico" },
    { nombre: "Farmacia" },
    { nombre: "Imágenes y Rayos X" },
    { nombre: "Ecografías" },
    { nombre: "Terapia y rehabilitación física" },
    { nombre: "Terapia respiratoria" },
    { nombre: "Odontología" },
    { nombre: "Servicios cardiológicos" },
    { nombre: "Terapia de lenguaje" }
  ];
  serviciosOcupacionales =
    [
      { nombre: "Exámenes pre, post y periódicos ocupacionales" },
      { nombre: "Charlas sobre Salud y Seguridad en el Trabajo" },
      { nombre: "Médico in situ" },
      { nombre: "Servicios móviles" }
    ];
  textoServicios= 'La Política se aplica a LA COMPAÑÍA, y a todos los servicios brindados, sean estos realizados por canales tecnológicos o presenciales. (Gestión personalizada en los Centros Médicos, página web y cualquier otro servicio brindado de manera digital o tradicional.';
  textoResponsabiliidad = 'LA COMPAÑÍA será responsable de los datos personales que nuestros usuarios faciliten para la prestación de nuestros servicios y garantizará la confidencialidad, integridad y disponibilidad de los datos personales facilitados por los clientes y su tratamiento automatizado o no de acuerdo con las leyes vigentes sobre protección de datos de carácter personal en el Ecuador y otras normativas aplicable.';
  textoControldeCambios= 'LA COMPAÑÍA puede realizar adecuaciones y cambios a la presente política comprometiéndose a notificar a los usuarios a través de nuestros canales oficiales de información cuando estos sean ejecutados. Sugerimos revisar de forma continua nuestros canales oficiales de comunicación para obtener información actualizada sobre la gestión de privacidad, en caso de discordancia con los cambios, puedes ejercer los derechos que te provee la ley orgánica de protección de datos personales'
  datosDemograficos = [
    { nombre: "Cédula de Ciudadanía / Pasaporte / RUC" },
    { nombre: "Dirección" },
    { nombre: "Estado Civil" },
    { nombre: "Fecha de Nacimiento" },
    { nombre: "Género" },
    { nombre: "Nombres y Apellidos" },
    { nombre: "País Residencia" },
    { nombre: "País Nacimiento" }
  ];
  datosContacto=[
    { nombre: "Correo electrónico" },
    { nombre: "Número Teléfono Móvil" },
    { nombre: "Número Teléfono Convencional" },
    { nombre: "Número Teléfono WhatsApp" },
    { nombre: "Usuarios de redes sociales" }
  ];
  datosHistoriaClinica= [
    { nombre: "Antecedentes Familiares" },
    { nombre: "Antecedentes Personales" },
    { nombre: "Diagnósticos" },
    { nombre: "Evolución de la enfermedad" },
    { nombre: "Hábitos (Alcohol, Cigarrillos, Alimenticios, Ejercicios)" },
    { nombre: "Medicamentos" },
    { nombre: "Motivo de Consulta" },
    { nombre: "Datos antropométricos" },
    { nombre: "Signos Vitales" },
    { nombre: "Antecedentes quirúrgicos" },
    { nombre: "Antecedentes alérgicos" },
    { nombre: "Resultados de Laboratorios" },
    { nombre: "Resultados de Imágenes" },
    { nombre: "Vacunas Recibidas" }
  ];
  datosTributarios = [
    { nombre: "Montos y Cantidades" },
    { nombre: "Productos que compras" },
    { nombre: "Seguro médico" },
    { nombre: "Situación crediticia" }
  ]
  datosAdicionales = [
    { nombre: "Ubicación GPS" },
    { nombre: "Fotos e Imágenes" },
    { nombre: "Video y Archivos" }
  ];
  textoUsodeDatos= `LA COMPAÑÍA requiere tus datos personales para analizar y mejorar la calidad de vida a través de mecanismos para el cuidado y la prevención de la salud según la necesidad de cada individuo. De igual manera son necesarios para proporcionar y personalizar nuestros servicios, con la ayuda de herramientas tecnológicas y analíticas para que sean más relevantes y útiles para ti, generando información valiosa para que puedas prevenir riesgos en tu salud basándonos en los datos registrados en tu Historia Clínica.
      Adicionalmente, LA COMPAÑÍA, con tu consentimiento, podrá generar notificaciones, comunicados y recordatorios para controlar tu salud y agendar próximas citas médicas, toma de medicinas, controles, entre otros, permitiendo entender tus necesidades. Este consentimiento permite a LA COMPAÑÍA ofrecer nuevos productos para satisfacer las necesidades de cada uno de nuestros clientes.`;
  textoCompartidoInformacion= `LA COMPAÑÍA comprometida con la ley orgánica de protección de datos personales vigente en el país, recibirá y compartirá los datos de manera exclusiva para tratamientos específicos detallados a continuación: <br>
    Compañías aseguradoras de Medicina Pre-Pagada bajo contratos con “LA COMPAÑÍA” se entrega información de los servicios prestados para auditorías médicas y valoración de coberturas. <br>
    Empresas por contrato de Salud Ocupacional entregando información específica de los colaboradores y empleados en los servicios o procedimientos realizados.
    Empresas aliadas estratégicamente como socios de negocios relacionados con servicios médicos como dispensarios, laboratorios, entre otros compartiendo información específica sobre los servicios contratados. <br>
    Empresas que contraten servicios médicos preocupacionales compartiendo información específica de sus colaboradores en los servicios contratados.
    Por requerimiento de autoridades competentes en el ámbito de salud, gobierno y de justicia tales como, Autoridad Sanitaria, Fiscalía, Jueces Civiles, Laborales o Penales, Ministerio de Salud pública (MSP), Comité de Operaciones de Emergencias (COE) entre otros. <br>
    Sin perjuicio y limitaciones “LA COMPAÑÍA” se reserva la posibilidad de realizar tratamientos y compartir datos personales de los usuarios para utilizarlos a través de sus socios de negocios, relacionados con los servicios de prestación médica autorizados por medio del consentimiento expreso, manteniendo y precautelando la confidencialidad de los datos personales.`;
  textoDerechosYObligaciones = ` "LA COMPAÑÍA" conservará tus datos personales a partir de la utilización de nuestros servicios, durante el tiempo necesario para la gestión y operación médica y administrativa.  En varios casos, se necesita mantener y conservar determinada información de manera indefinida como los registros de Historia Clínica y Datos Comerciales obligatorios por obligaciones tributarias y otras normativas.`;
  textoDerechoDatosPersonales =`Los clientes o usuario(s) pueden ejercer los derechos que le otorga la ley para  <span class="fw-bolder">rechazar el uso y tratamiento de los datos personales</span> no esenciales para el análisis y atención de los servicios provistos por LA COMPAÑÍA como promociones, campañas publicitarias, recordatorios de tratamientos médicos, análisis profesionales del estado de tu estado de salud, por lo tanto, el usuario rechaza expresamente nuestros servicios de acompañamiento para mejorar las condiciones de salud. <br>

De igual manera LA COMPAÑÍA <span class="fw-bolder">se reserva el derecho de emitir recordatorios de citas o servicios solicitados expresamente para evitar ausencias</span> que perjudiquen la oportunidad de atender a otras personas que requieran nuestros servicios. <br>

Adicionalmente, los usuarios pueden <span class="fw-bolder"> oponerse al uso de los datos </span> cuyo tratamiento, no cumpla con lo estipulado por la Ley Orgánica de protección de datos personales. <br>

Puedes solicitar que se <span class="fw-bolder"> rectifiquen o actualicen tus datos personales </span> recopilados en la gestión de nuestros servicios presentando las justificaciones y requisitos pertinentes. <br>

La ley te otorga la posibilidad de requerir de manera gratuita y sin justificación, sin constituirse en un abuso de derechos, una copia de los datos personales que almacenamos en nuestros sistemas informáticos.`;
  textoEliminacionDatos= `Podrán ser borrados y eliminados los datos de contacto como redes sociales (Facebook, Instagram, Twitter y Número de WhatsApp) <br>
No pueden ser eliminados los datos de Registro de Historia Clínica y datos tributarios ya que se conservan por temas normativos. <br>
El cliente podrá solicitar que se limite el uso de sus datos de Historia Clínica y datos comerciales para que no sea objeto de análisis en el uso de calculadoras médicas, tratamientos finalizados, temas relativos a la prevención de salud, campañas promocionales o marketing aceptando que LA COMPAÑÍA no podrá personalizar los servicios que te facilitamos a través de nuestros canales de atención y experiencia del usuario. <br>


Cualquier dato cuyo tratamiento, no cumpla con lo que determine la LOPDP podrá ser eliminado.`;
  textoFinalizacionServicios= `A pesar de solicitar la eliminación de tus datos personales, LA COMPAÑÍA se reserva el derecho a mantener datos relativos a    la Historia Clínica que se conservarán de manera legal hasta la muerte del titular y los datos tributarios se conservarán por obligaciones tributarias, legales, gubernamentales o de salud pública. <br>



LA COMPAÑÍA garantizará la confidencialidad de los datos de carácter personal facilitados por los clientes y su tratamiento automatizado de acuerdo con la legislación ecuatoriana vigente y se compromete a usar los datos personales recibidos, exclusivamente para los fines específicos para los cuales el usuario los proporcionó. Sin perjuicio de ello, se reserva la posibilidad de realizar el tratamiento de datos personales de los clientes para utilizarlos a través de sus socios de negocios en la prestación de servicios médicos. Por tal razón el cliente entrega su consentimiento expreso. <br>



LA COMPAÑÍA ha adoptado los niveles de seguridad de protección de los datos personales legalmente requeridos, y ha instalado todos los medios y medidas técnicas a su alcance para minimizar la posibilidad de pérdida, mal uso, alteración, acceso no autorizado y robo de los datos personales de nuestros clientes, aclarando que no existen niveles de seguridad 100% confiables, pero con el compromiso de velar y realizar los esfuerzos para proteger los datos personales suministrados por los usuarios. Sin embargo, por cumplimiento de obligaciones contractuales legales asumidas con terceros o por orden judicial se p podrá revelar algunos de los datos que el caso amerite. <br>



El usuario asume la responsabilidad entregar datos válidos eximiendo de esta responsabilidad a LA COMPAÑÍA en caso de error u omisión de la información proporcionada.`
  correoElectronico = "datospersonales@medilink.com.ec"
  formPaginaWeb= "www.medilink.com.ec"




}
